<template>
  <Train>
    <template #train>
      <MPTaktarea v-for="(taktarea, taktarea_index) in taktareas" :key="`taktarea${taktarea.id}`" :project_id="project.id"
        :train="train" :train_index="train_index" :taktarea="taktarea" :taktarea_index="taktarea_index" />
    </template>
  </Train>
</template>
<script>
import { mapGetters } from 'vuex';

import Train from '@/components/ProjectTaktPlan/Train.component.vue';
import MPTaktarea from '@/views/MultiProject/MPTaktarea.wrapper.vue';

export default {
  props: ['project', 'train', 'train_index'],
  components: {
    Train,
    MPTaktarea,
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
    ]),
    taktareas() {
      let taktareas = this.getUObjects({ type: 'taktareas', ids: this.train.taktareas });
      if (this.$store.state.View.taktarea_filter) {
        // store this.$store.state.View.taktarea_filter separated by ; in filter variable
        let filter = this.$store.state.View.taktarea_filter.split(';');

        // filter taktareas by an additive filter for name and description
        taktareas = taktareas.filter(taktarea => {
          let filter_result = false;
          filter.forEach(filter_item => {
            if (taktarea.name.toLowerCase().includes(filter_item.toLowerCase()) ||
              taktarea.description.toLowerCase().includes(filter_item.toLowerCase())) {
              filter_result = true;
            }
          });
          return filter_result;
        });

      }
      return taktareas;
    }
  }
}
</script>
<style>
.class {}
</style>
